const CHALLENGES_DATA = {
    superiority: {
        place: 300,
        points: 1000,
    },
    onslaught: {
        first_place_reward: {
            gold: 7000,
            credits: 500,
            reserves: [
                {
                    type: 'TACTICAL_TRAINING',
                    count: 2,
                    level: 11,
                },{
                    type: 'ADDITIONAL_BRIEFING',
                    count: 2,
                    level: 11,
                },{
                    type: 'HIGH_CAPACITY_TRANSPORT',
                    count: 2,
                    level: 11,
                },{
                    type: 'REQUISITION',
                    count: 2,
                    level: 11,
                },
            ],
        },
    },
    shooting: {
        points_lack: 2000,
        place: null,
        points: 1000,
    },
    conscription: null,
}

const CHALLENGES_META = {
    calculated_at: require('moment')().subtract(3, 'minutes').valueOf(),
    start_datetime: require('moment')().subtract(3, 'hours').valueOf(),
    end_datetime: require('moment')().add(40, 'minutes').valueOf(),
    challenge_id: 30,
    prev_challenge_id: 144,
    next_challenge_id: null,
    final_calculation_in_progress: false,
    update_frequency: 60,
}

export default { data: CHALLENGES_DATA, meta: CHALLENGES_META }



// WEBPACK FOOTER //
// ./containers/Challenges/mock.js